(function(){
  function qs(sel, root){return (root||document).querySelector(sel)}
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function enc(v){return v == null ? '' : String(v)}
  function cleanTerm(v){return String(v||'').replace(/\s+/g,' ').trim()}
  function normal(v){return cleanTerm(v).toLowerCase()}
  function getCollectionHandle(root){
    var explicit = root.getAttribute('data-bco-collection-handle');
    if(explicit) return explicit;
    var p = new URLSearchParams(window.location.search);
    var fromQuery = p.get('bco_collection');
    if(fromQuery) return fromQuery;
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function itemLabel(item){return typeof item === 'string' ? item : item.label}
  function itemCount(item){return (typeof item === 'string' || item.count == null || item.count === 0) ? '' : ' ('+item.count+')'}
  function isNonKnifeCollection(meta){return meta && meta.knife === false;}
  function appendParam(params, name, value){ if(name && value !== '' && value != null) params.append(name, value); }
  var BCO_TAG_PREFIX = {
    blade_length: 'Blade Length: ',
    blade_material: 'Blade Material: ',
    blade_type: 'Blade Type: ',
    lock_type: 'Lock Type: ',
    handle_material: 'Handle: ',
    blade_finish: 'Blade Finish: ',
    color: 'Colour: ',
    origin: 'Origin: '
  };
  function tagForField(field, value){
    var prefix = BCO_TAG_PREFIX[field];
    return prefix && cleanTerm(value) ? prefix + cleanTerm(value) : '';
  }
  function ensureState(root){
    root.__bcoFieldSelections = root.__bcoFieldSelections || {};
    return root.__bcoFieldSelections;
  }
  function addState(root, field, value){
    var state = ensureState(root);
    state[field] = state[field] || {};
    if(cleanTerm(value)) state[field][normal(value)] = cleanTerm(value);
  }
  function removeState(root, field, value){
    var state = ensureState(root);
    if(state[field]) delete state[field][normal(value)];
  }
  function getStateValues(root, field){
    var state = ensureState(root);
    return state[field] ? Object.keys(state[field]).map(function(k){return state[field][k]}).filter(Boolean) : [];
  }
  function syncStateFromDom(root){
    qsa('input[data-bco-field]', root).forEach(function(input){
      var field = input.getAttribute('data-bco-field');
      if(!field) return;
      if(input.checked) addState(root, field, input.value);
      else removeState(root, field, input.value);
    });
  }
  function loadOptions(root, field, list, limit){
    var box = qs('[data-bco-options="'+field+'"]', root);
    if(!box) return;
    var selectedMap = {};
    getStateValues(root, field).forEach(function(v){ selectedMap[normal(v)] = true; });
    qsa('input[data-bco-field="'+field+'"]:checked', root).forEach(function(input){ selectedMap[normal(input.value)] = true; addState(root, field, input.value); });
    box.innerHTML = '';
    var term = normal((qs('[data-bco-option-search="'+field+'"]', root)||{}).value || '');
    var shown = 0;
    (list||[]).forEach(function(item){
      var label = itemLabel(item);
      if(!label) return;
      if(term && label.toLowerCase().indexOf(term) === -1) return;
      if(!term && limit && shown >= limit && !selectedMap[normal(label)]) return;
      shown++;
      var lab = document.createElement('label');
      lab.className = 'bco-large-filter__option';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('data-bco-field', field);
      input.value = label;
      input.checked = !!selectedMap[normal(label)];
      var span = document.createElement('span');
      span.textContent = label;
      var cnt = itemCount(item);
      if(cnt){ var small = document.createElement('small'); small.textContent = cnt; span.appendChild(small); }
      lab.appendChild(input);
      lab.appendChild(span);
      box.appendChild(lab);
    });
    if(shown === 0){ box.innerHTML = '<div class="bco-large-filter__empty">No matching options</div>'; }
  }

  function selectedValuesFromParams(name){
    var p = new URLSearchParams(window.location.search);
    var vals = p.getAll(name);
    var single = p.get(name);
    if(single && vals.indexOf(single) === -1) vals.push(single);
    return vals.map(function(v){return cleanTerm(v);}).filter(Boolean);
  }
  function qHaystack(){
    var q = new URLSearchParams(window.location.search).get('q') || '';
    try{ q = decodeURIComponent(q); }catch(e){}
    return normal(q);
  }
  function restoreSelections(root){
    var p = new URLSearchParams(window.location.search);
    var avail = p.get('filter.v.availability');
    if(avail){
      var availInput = qs('input[name="bco_availability"][value="'+avail.replace(/"/g,'\\"')+'"]', root);
      if(availInput) availInput.checked = true;
    }
    var min = p.get('filter.v.price.gte') || '';
    var max = p.get('filter.v.price.lte') || '';
    var minInput = qs('[data-bco-price-min]', root);
    var maxInput = qs('[data-bco-price-max]', root);
    if(minInput) minInput.value = min;
    if(maxInput) maxInput.value = max;
    selectedValuesFromParams('filter.p.vendor').forEach(function(v){ addState(root, 'brand', v); });
    selectedValuesFromParams('filter.p.tag').forEach(function(v){
      Object.keys(BCO_TAG_PREFIX).forEach(function(field){
        var prefix = BCO_TAG_PREFIX[field];
        if(v.indexOf(prefix) === 0){ addState(root, field, v.slice(prefix.length)); }
      });
    });
    var hay = qHaystack();
    qsa('input[data-bco-field]', root).forEach(function(input){
      var field = input.getAttribute('data-bco-field');
      var val = normal(input.value);
      if(!val) return;
      if(getStateValues(root, field).map(normal).indexOf(val) !== -1){ input.checked = true; return; }
      if(field !== 'brand' && hay && hay.indexOf(val) !== -1){ input.checked = true; addState(root, field, input.value); }
    });
  }
  function setDesktopMobileOpen(root){
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    qsa('details[data-bco-filter-group]', root).forEach(function(d){
      if(!isMobile){ d.open = true; return; }
      var group = d.getAttribute('data-bco-filter-group');
      var hasSelected = false;
      if(group === 'availability') hasSelected = !!qs('input[name="bco_availability"]:checked', root);
      else if(group === 'price') hasSelected = !!(cleanTerm((qs('[data-bco-price-min]', root)||{}).value||'') || cleanTerm((qs('[data-bco-price-max]', root)||{}).value||''));
      else hasSelected = getStateValues(root, group).length > 0 || !!qs('input[data-bco-field="'+group+'"]:checked', root);
      d.open = d.hasAttribute('data-bco-mobile-priority') || hasSelected;
    });
  }
  function chipButton(label, onRemove){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bco-large-filter__pill';
    btn.appendChild(document.createTextNode(label));
    var x = document.createElement('span');
    x.setAttribute('aria-hidden','true');
    x.textContent = '×';
    btn.appendChild(x);
    btn.addEventListener('click', onRemove);
    return btn;
  }
  function updateActiveFilters(root){
    syncStateFromDom(root);
    var wrap = qs('[data-bco-active-filters]', root);
    var apply = qs('[data-bco-apply]', root);
    var count = 0;
    if(wrap) wrap.innerHTML = '';
    var avail = qs('input[name="bco_availability"]:checked', root);
    if(avail){
      count++;
      if(wrap) wrap.appendChild(chipButton(avail.value === '1' ? 'In stock' : 'Out of stock', function(){ avail.checked = false; updateActiveFilters(root); setDesktopMobileOpen(root); }));
    }
    var minInput = qs('[data-bco-price-min]', root), maxInput = qs('[data-bco-price-max]', root);
    var min = cleanTerm((minInput||{}).value || ''), max = cleanTerm((maxInput||{}).value || '');
    if(min || max){
      count++;
      var priceLabel = min && max ? ('$'+min+' – $'+max) : (min ? ('$'+min+'+') : ('Under $'+max));
      if(wrap) wrap.appendChild(chipButton(priceLabel, function(){ if(minInput) minInput.value=''; if(maxInput) maxInput.value=''; updateActiveFilters(root); setDesktopMobileOpen(root); }));
    }
    var names = {
      brand:'Brand', blade_length:'Blade length', blade_material:'Steel', blade_type:'Blade type', lock_type:'Lock type', handle_material:'Handle', blade_finish:'Finish', color:'Color', origin:'Origin'
    };
    Object.keys(names).forEach(function(field){
      getStateValues(root, field).forEach(function(value){
        count++;
        if(wrap) wrap.appendChild(chipButton(names[field]+': '+value, function(){
          removeState(root, field, value);
          qsa('input[data-bco-field="'+field+'"]', root).forEach(function(i){ if(normal(i.value) === normal(value)) i.checked = false; });
          updateActiveFilters(root);
          setDesktopMobileOpen(root);
        }));
      });
    });
    if(wrap){
      wrap.style.display = count ? 'flex' : 'none';
    }
    if(apply){
      apply.textContent = count ? ('Apply selected filters ('+count+')') : 'Apply filters';
    }
  }

  function populate(root){
    var data = window.BCO_FILTER_DATA || {options:{},collections:{}};
    var handle = getCollectionHandle(root);
    var meta = data.collections && data.collections[handle] ? data.collections[handle] : null;
    var searchWrap = root.closest ? root.closest('.pk-search-filters') : null;
    root.hidden = false;
    if(searchWrap) searchWrap.hidden = false;
    var countEl = qs('[data-bco-filter-count]', root);
    if(countEl){ countEl.textContent = meta && meta.count ? meta.count.toLocaleString() + ' products' : ''; }
    var titleEl = qs('[data-bco-filter-source]', root);
    if(titleEl && meta && meta.title){ titleEl.textContent = meta.title; }
    var opts = (meta && meta.options) ? meta.options : (data.options || {});
    function listFor(field){ return opts[field === 'brand' ? 'brands' : field] || []; }
    function renderOptions(){
      loadOptions(root, 'brand', listFor('brand'), 80);
      loadOptions(root, 'blade_length', listFor('blade_length'), 100);
      loadOptions(root, 'blade_material', listFor('blade_material'), 50);
      loadOptions(root, 'blade_type', listFor('blade_type'), 100);
      loadOptions(root, 'lock_type', listFor('lock_type'), 50);
      loadOptions(root, 'handle_material', listFor('handle_material'), 50);
      loadOptions(root, 'blade_finish', listFor('blade_finish'), 100);
      loadOptions(root, 'color', listFor('color'), 50);
      loadOptions(root, 'origin', listFor('origin'), 50);
      ['brand','blade_length','blade_material','blade_type','lock_type','handle_material','blade_finish','color','origin'].forEach(function(field){
        var group = qs('[data-bco-filter-group="'+field+'"]', root);
        if(!group) return;
        var list = listFor(field);
        if(!list.length) group.classList.add('bco-filter-hidden-for-context');
        else group.classList.remove('bco-filter-hidden-for-context');
      });
    }
    renderOptions();
    restoreSelections(root);
    renderOptions();
    if(isNonKnifeCollection(meta)){
      qsa('[data-bco-knife-filter]', root).forEach(function(el){el.classList.add('bco-filter-hidden-for-context')});
    } else {
      qsa('[data-bco-knife-filter]', root).forEach(function(el){ if((listFor(el.getAttribute('data-bco-filter-group')) || []).length) el.classList.remove('bco-filter-hidden-for-context') });
    }
    setDesktopMobileOpen(root);
    updateActiveFilters(root);
    qsa('[data-bco-option-search]', root).forEach(function(input){
      input.addEventListener('input', function(){
        var field = input.getAttribute('data-bco-option-search');
        var limit = field === 'brand' ? 80 : 50;
        loadOptions(root, field, listFor(field), limit);
        updateActiveFilters(root);
      });
    });
  }
  function buildUrl(root){
    updateActiveFilters(root);
    var data = window.BCO_FILTER_DATA || {collections:{}};
    var handle = getCollectionHandle(root);
    var meta = data.collections && data.collections[handle] ? data.collections[handle] : null;

    /*
      IMPORTANT:
      When a shopper starts from a collection page, keep the result inside that
      same collection. The previous fallback sent them to /search with a tag
      parameter, but Shopify search can ignore that collection tag and show all
      products from a selected vendor. Example: Flashlights + Browning was showing
      Browning knives. Collection URLs preserve the collection boundary.
    */
    var avail = qs('input[name="bco_availability"]:checked', root);
    var min = cleanTerm((qs('[data-bco-price-min]', root)||{}).value || '');
    var max = cleanTerm((qs('[data-bco-price-max]', root)||{}).value || '');
    var names = ['brand','blade_length','blade_material','blade_type','lock_type','handle_material','blade_finish','color','origin'];

    var collectionCount = meta && meta.count ? Number(meta.count) : 0;
    var useSearchFallback = !!(handle && collectionCount > 5000);

    /*
      Shopify ignores native filter.p.* params on collections above 5,000 products.
      For those mega collections, keep the shopper in a filtered product search instead
      of staying on /collections/{handle}?filter.p.vendor=... where the grid still shows
      the whole collection. Smaller collections keep the collection URL so the boundary
      remains exact.
    */
    if(handle && !useSearchFallback){
      var cparams = new URLSearchParams();
      if(avail && avail.value){ appendParam(cparams, 'filter.v.availability', avail.value); }
      if(min) appendParam(cparams, 'filter.v.price.gte', min);
      if(max) appendParam(cparams, 'filter.v.price.lte', max);
      getStateValues(root, 'brand').forEach(function(val){ appendParam(cparams, 'filter.p.vendor', val); });
      names.forEach(function(field){
        if(field === 'brand') return;
        getStateValues(root, field).forEach(function(val){
          var tag = tagForField(field, val);
          if(tag) appendParam(cparams, 'filter.p.tag', tag);
        });
      });
      var collectionUrl = '/collections/' + encodeURIComponent(handle);
      var query = cparams.toString();
      return query ? (collectionUrl + '?' + query) : collectionUrl;
    }

    var params = new URLSearchParams();
    params.set('type','product');
    params.set('options[prefix]','last');
    var qTerms = [];
    var existingQ = cleanTerm(new URLSearchParams(window.location.search).get('q') || '');
    if(existingQ && existingQ !== '*') qTerms.push(existingQ);

    if(handle && useSearchFallback){
      params.set('bco_collection', handle);
      if(meta && meta.base){
        meta.base.forEach(function(base){
          if(base && base.name && base.value){
            appendParam(params, base.name, base.value);
            if(base.name === 'filter.p.tag') qTerms.push(base.value);
          }
        });
      }
      var handleQueryMap = {
        'fixed-blade-knives': 'fixed blade',
        'folding-knives': 'folding knife',
        'locking-knives': 'locking knife',
        'pocket-knives-under-50': 'pocket knife',
        'pocket-knives-under-100': 'pocket knife'
      };
      if(!qTerms.length && handleQueryMap[handle]) qTerms.push(handleQueryMap[handle]);
    }

    if(avail && avail.value){ appendParam(params, 'filter.v.availability', avail.value); }
    if(min) appendParam(params, 'filter.v.price.gte', min);
    if(max) appendParam(params, 'filter.v.price.lte', max);
    names.forEach(function(field){
      getStateValues(root, field).forEach(function(val){
        if(field === 'brand') appendParam(params, 'filter.p.vendor', val);
        else {
          var tag = tagForField(field, val);
          if(tag) appendParam(params, 'filter.p.tag', tag);
          qTerms.push(val);
        }
      });
    });
    params.set('q', qTerms.length ? qTerms.join(' ') : '*');
    return '/search?' + params.toString();
  }
  function init(root){
    if(root.__bcoFilterInit) return; root.__bcoFilterInit = true;
    populate(root);
    qsa('[data-bco-price-preset]', root).forEach(function(btn){
      btn.addEventListener('click', function(){
        var min = btn.getAttribute('data-min') || '';
        var max = btn.getAttribute('data-max') || '';
        var minInput = qs('[data-bco-price-min]', root);
        var maxInput = qs('[data-bco-price-max]', root);
        if(minInput) minInput.value = min;
        if(maxInput) maxInput.value = max;
        updateActiveFilters(root);
        setDesktopMobileOpen(root);
      });
    });
    root.addEventListener('change', function(e){
      if(e.target && (e.target.matches('input[data-bco-field]') || e.target.matches('input[name="bco_availability"]'))){
        updateActiveFilters(root);
        setDesktopMobileOpen(root);
      }
    });
    root.addEventListener('input', function(e){
      if(e.target && (e.target.matches('[data-bco-price-min]') || e.target.matches('[data-bco-price-max]'))){
        updateActiveFilters(root);
        setDesktopMobileOpen(root);
      }
    });
    var form = qs('[data-bco-large-filter-form]', root);
    if(form){
      form.addEventListener('submit', function(e){ e.preventDefault(); window.location.href = buildUrl(root); });
    }
    var clear = qs('[data-bco-clear]', root);
    if(clear){
      clear.addEventListener('click', function(e){
        e.preventDefault();
        var handle = getCollectionHandle(root);
        var isSearch = root.getAttribute('data-bco-context') === 'search';
        window.location.href = handle ? '/collections/' + encodeURIComponent(handle) : (isSearch ? '/search' : '/collections/all');
      });
    }
    if(window.matchMedia){
      var mq = window.matchMedia('(max-width: 989px)');
      if(mq.addEventListener) mq.addEventListener('change', function(){ setDesktopMobileOpen(root); });
      else if(mq.addListener) mq.addListener(function(){ setDesktopMobileOpen(root); });
    }
  }
  function boot(){ qsa('[data-bco-large-filter]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
